/* TomorrowMade — collection / list-collections behavior:
   filter chips, marquee, and quick-add from product cards. */
(function () {
  'use strict';

  /* filter chips (list-collections) */
  var chips = document.querySelectorAll('.chip');
  var groups = document.querySelectorAll('.cgroup');
  var fcount = document.getElementById('fcount');
  if (chips.length && groups.length) {
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        var f = ch.getAttribute('data-filter');
        chips.forEach(function (c) { c.classList.toggle('on', c === ch); });
        var total = 0;
        groups.forEach(function (g) {
          var show = f === 'all' || g.getAttribute('data-collection') === f;
          g.hidden = !show;
          if (show) {
            total += parseInt(g.getAttribute('data-count') || '0', 10);
            if (typeof gsap !== 'undefined' && !(window.TM && window.TM.reduce)) {
              gsap.fromTo(g, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.6, ease: 'expo.out' });
            }
          }
        });
        if (fcount) fcount.textContent = total + ' designs';
        if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
      });
    });
  }

  /* quick-add from a product card */
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) { return; }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      var url = btn.getAttribute('data-product-url');
      // multi-variant or unknown → go to product page to choose options
      if (!vid || btn.getAttribute('data-multi') === 'true') { if (url) location.href = url; return; }
      if (!window.fetch) { if (url) location.href = url; return; }
      btn.classList.add('added');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function (item) {
        toast('Added — ' + item.product_title);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        document.querySelectorAll('.nav__shop').forEach(function (el) {
          el.innerHTML = (el.getAttribute('data-base-label') || 'Cart') + (cart.item_count > 0 ? ' (' + cart.item_count + ')' : '');
        });
      }).catch(function () { if (url) location.href = url; })
        .finally(function () { setTimeout(function () { btn.classList.remove('added'); }, 1400); });
    });
  });

  /* marquee */
  var mq = document.getElementById('mq1');
  if (mq && !mq.innerHTML.trim()) {
    var items = (window.TM_MARQUEE && window.TM_MARQUEE.length) ? window.TM_MARQUEE
      : ['Move Different', 'Built Through Pressure', 'Clarity / Focus', 'Midnight State', 'Built Like Stone', 'Forward Always'];
    var html = '';
    for (var r = 0; r < 2; r++) { items.forEach(function (t) { html += '<span>' + t + '<b> ///</b><i class="dot"></i></span>'; }); }
    mq.innerHTML = html;
    window.addEventListener('load', function () {
      if (typeof gsap !== 'undefined' && !(window.TM && window.TM.reduce)) {
        var w = mq.scrollWidth / 2; gsap.to(mq, { x: -w, duration: 30, ease: 'none', repeat: -1 });
      }
    });
  }
})();
